export default "__VITE_ASSET__Bp65EokV__"